import React, { Fragment, useEffect, useState } from "react";
import Cookies from "universal-cookie";
import logo from "../assets/images/logo.svg";
import mobImg from "../assets/images/signup-image-01.svg";

function HomePage() {



  const [isload, setLoad] = useState(false);
  useEffect(() => {
    // if (!didMount.current) {
    const cookies = new Cookies();
    const _loginForm = cookies.get("loginForm");
    if (_loginForm !== undefined) {
      // Object.keys(_loginForm).forEach(cookieName => {
      //   inputValue[cookieName] = _loginForm[cookieName];
      // });


    }
    // setInputValue({ ...inputValue });
    setLoad(true);
    // }
    // return () => {
    //   didMount.current = true;
    // };
  }, []);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);
    const handlePopState = () => {
      window.history.pushState(null, "", window.location.href);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);


  return (
    <Fragment>
      {" "}
      {isload && (
        <>
          <div className="login-page-header">
            <a href="/" className="logo-container">
              <img src={logo} alt="InstaDouch Logo" className="logo" />
            </a>

            {/* <nav className="NavBar1">
              <div className="NavBarDiv">
                <ul id="NavBarUl">
                  <li id="NavBarLi"><a href="/homepage" className="nav-menu-item login-link NavBarA">Home</a></li>
                  <li id="NavBarLi"><a href="/company" className="nav-menu-item NavBarA">Company</a></li>
                  <li id="NavBarLi"><a href="/employers" className="nav-menu-item NavBarA">Employers</a></li>
                  <li id="NavBarLi"><a href="/employees" className="nav-menu-item NavBarA">Employees</a></li>
                  <li id="NavBarLi"><a href="/fAQs" className="nav-menu-item NavBarA">FAQs</a></li>
                  <li id="NavBarLi"><a href="/" className="nav-menu-item NavBarA">
                    Login
                    <div className="login-dropdown-container">
                      <a href="#" className="login-dropdown-link-item">
                        Employee Login
                      </a>
                      <a href="#" className="login-dropdown-link-item">
                        Employer Login
                      </a>
                    </div>
                  </a></li>
                </ul>
              </div>
            </nav> */}
            <nav>
              <a href="/homepage" className="nav-menu-item login-link">
                Home
              </a>
              <a href="/company" className="nav-menu-item">
                Company
              </a>
              <a href="/employers" className="nav-menu-item">
                Employers
              </a>
              <a href="/employees" className="nav-menu-item">
                Employees
              </a>
              <a href="/fAQs" className="nav-menu-item">
                FAQs
              </a>
              <a href="/" className="nav-menu-item">
                Login
                {/* <div className="login-dropdown-container">
                  <a href="#" className="login-dropdown-link-item">
                    Employee Login
                  </a>
                  <a href="#" className="login-dropdown-link-item">
                    Employer Login
                  </a>
                </div> */}
              </a>
            </nav>
          </div>
          {/* <div className="container1"> */}
          {/* <div className="insta-dough-desc-container">
              <h3>Instantly Access your Dough</h3>
              <ul>
                <li>Fast</li>
                <li>Secure</li>
                <li>Easy</li>
              </ul>
              <p>
                Get your earned wages today. Spend on your card, withdraw at an
                ATM, or transfer to your bank!
              </p>
              <p>It’s your money, get it when you need it!</p>
            </div> */}
          {/* </div> */}
          {/* Login screen end  */}
          <div class="public-page-container">
            <div class="public-page-wrapp">
              <div class="public-page-image-left">
                <a href="#" className="logo-container">
                  <img src={mobImg} alt="InstaDouch Logo" className="logo" />
                </a>
              </div>

              <div class="public-page-content-right">
                <h2 class="login-register-form-heading mt-40 mb-20">
                  Instantly Access <span>your Dough</span>
                </h2>

                <div class="public-page-insta-dough-desc-container">
                  <h3>Instantly Access your Dough</h3>
                  <ul>
                    <li>Fast</li>
                    <li>Secure</li>
                    <li>Easy</li>
                  </ul>
                  <p>
                    Get your earned wages today. Spend on your card, withdraw at an
                    ATM, or transfer to your bank!
                  </p>
                  <p>It’s your money, get it when you need it!</p>
                </div>

                <div class="form-row">
                  <p class="color-white">
                    Use InstaDough’s DoughPay product to get your earned money today!
                    We know that you have bills today, why should you wait until
                    payday to access your money… DoughPay is your solution.
                    <br />
                    <br />
                    It’s easy, register your account, instantly see your eligible
                    wages to access, and start accessing your money! Let’s get
                    doughy...
                    <br />
                    <br />
                    Employer and want to sign-up to help free your employees from
                    financial strain?
                    <br />
                    <br />
                    Employee ready to activate your account?
                    <br />
                    <br />
                    Want to refer your employer and earn $50 referral fee?
                  </p>
                </div>
              </div>
            </div>


          </div>

        </>
      )}
    </Fragment>
  );
}

export default HomePage;
